/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Determines how to find the target row when saving a form answer to a table.
 */
export enum SaveToTableTargetingMode {
    ENTITY = 'Entity',
    FORM_RESPONSE = 'FormResponse',
    WORKFLOW = 'Workflow',
    LINKED_ENTITY = 'LinkedEntity',
    FIRST_ROW = 'FirstRow',
}
